import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-max-discounts-limit',
  templateUrl: './max-discounts-limit.page.html',
  styleUrls: ['./max-discounts-limit.page.scss'],
})
export class MaxDiscountsLimitPage {

  constructor(private modalCtrl: ModalController) { }
  
  public onDismiss() {
    this.modalCtrl.dismiss(false);
  }
  
  public onConfirm() {
    this.modalCtrl.dismiss(true);
  }

}
